import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState } from './patchApplicationHandlers';

export const enrichAccountInformationHandlers = [
    http.patch('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/enrichAccountInformation', async () => {
        // Simulate the next step in the flow
        const session = MockServiceWorker.getMockedSession();
        session.state = getNextState('DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT');
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json([]);
    }),
];
